import { LitElement, html, utils } from '@hh/global.js'
const {
  getCart,
  addToCart,
  updateCart,
  reRenderShopifySections,
} = utils

class HHHeader extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    window.addEventListener('mini-cart:toggle', this.toggleCart.bind(this))
    window.addEventListener('cart:changed', this.validateGwp.bind(this))

    this._boundHandleClick = this.handleMenuButtonClick.bind(this)
    this._boundHandleMouseEnter = this.handleMenuButtonMouseEnter.bind(this)
    this._boundHandleMouseLeave = this.handleMenuButtonMouseLeave.bind(this)

    this.menuButtons = this.querySelectorAll('.js-menu-button')
    this.menuButtons.forEach((button) => {
      button.addEventListener('click', this._boundHandleClick)
      button.addEventListener('mouseenter', this._boundHandleMouseEnter)
      button.addEventListener('mouseleave', this._boundHandleMouseLeave)
    })

    this.checkGwp()
  }

  disconnectedCallback() {
    super.disconnectedCallback()

    window.removeEventListener('mini-cart:toggle', this.toggleCart)
    window.removeEventListener('cart:changed', this.validateGwp)

    this.menuButtons.forEach((button) => {
      button.removeEventListener('click', this._boundHandleClick)
      button.removeEventListener('mouseenter', this._boundHandleMouseEnter)
      button.removeEventListener('mouseleave', this._boundHandleMouseLeave)
    })
  }

  handleMenuButtonClick(e) {
    if (this.canHover) return
    this.dispatchEvent(
      new CustomEvent('toggleMegaMenu', {
        bubbles: true,
        detail: { clickEvent: e },
      })
    )
  }

  get canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches
  }

  handleMenuButtonMouseEnter(e) {
    if (!this.canHover) return
    this.dispatchEvent(
      new CustomEvent('toggleMegaMenu', {
        bubbles: true,
        detail: { clickEvent: e, hoverOpen: true },
      })
    )
  }

  handleMenuButtonMouseLeave() {
    if (!this.canHover) return
    this.dispatchEvent(new CustomEvent('scheduleMegaMenuClose', { bubbles: true }))
  }

  closeOpenModals(e) {
    utils.all('hh-details-modal', this).map((element) => {
      if (element !== e.detail.value) {
        element.setAttribute('open', false)
      }
    })
  }

  toggleCart(e) {
    e?.detail?.event?.preventDefault()
    utils.toggle(document.body, ['mini-cart-is-visible'])

    setTimeout(() => {
      utils.toggle(document.querySelector('html'), ['overflow-hidden'])
      utils.toggle(document.body, ['mini-cart-is-active'])
      utils.toggle(document.querySelector('.js-mega-menu-overlay'), ['active'])
    });
  }

  async checkGwp () {
    const cart = await getCart()
    this.validateGwp({
      detail: {
        cart
      }
    })
  }

  async validateGwp (event) {
    if (!window.gwp.enabled) return;

    const { items, items_subtotal_price: subTotal } = event.detail.cart;

    let cart
    const updates = {}
    const discountsByAmounts = window.gwp.discounts.filter(discount => discount.minimums === 'minimum-purchase-amt' && subTotal >= discount.minPurchaseAmount * 100)

    items.filter(item => !!item.properties?._gwp)
      .filter(item => {
        const appliedDiscount = discountsByAmounts.find(discount => discount.id === item.properties._gwp)
        return !(appliedDiscount?.id == item.properties._gwp && item.quantity === appliedDiscount.giftQuantity)
      }).map(item => updates[item.key] = 0)

    let itemsToAdd = discountsByAmounts.map(discount => {
      const itemInCart = items.find(item => item.properties?._gwp === discount.id)

      return {
        id: discount.giftId,
        quantity: (discount.giftQuantity - (itemInCart?.quantity || 0)),
        properties: {
          _gwp: discount.id
        }
      }
    }).filter(item => item.quantity > 0)

    if (window.gwp.disableAutoAdd) {
      const removedItems = (sessionStorage.getItem('removedGWP') || '').split(',').filter(item => !!item)
        .map(item => +item)
      itemsToAdd = itemsToAdd.filter(item => !removedItems.includes(item.properties._gwp))
    }

    const sections = !!document.querySelector('#inline-cart')?.dataset?.id ? `${document.querySelector('#inline-cart')?.dataset?.id},header` : 'mini-cart,header'

    if (Object.keys(updates).length > 0) cart = await updateCart({ updates, sections });
    if (itemsToAdd.length > 0) cart = await addToCart({ items: itemsToAdd, sections });
    if (!!cart) reRenderShopifySections(cart)
  }

  render() {
    return html`<slot
      @modalOpened="${this.closeOpenModals}"
      @toggleCart="${this.toggleCart}"
    ></slot>`
  }
}

customElements.define('hh-header', HHHeader)
